import * as actions from 'redux/actions/domainsData.actions'
import updateCompetitors from './updateCompetitors'
import updateKeyword from './updateKeyword'

const findAndUpdate = (keywordsList, amendsList, type) => {
  return keywordsList.map(mainKeyword => {
    const amendKeyword = amendsList.find(keyword => keyword.id === mainKeyword.id)
    if (amendKeyword) {
      return updateKeyword(mainKeyword, amendKeyword, type)
    }
    return updateKeyword({}, mainKeyword, type)
  })
}

const updateKeywords = (existingKeywords, data, type) => {
  switch (type) {
    case actions.loadKeywordsSuccess.type: {
      return findAndUpdate(data, [], type)
    }
    case actions.loadKeywordsResultsSuccess.type:
    case actions.loadKeywordsChangesSuccess.type: {
      return findAndUpdate(existingKeywords, data, type)
    }
    case actions.loadKeywordsCompetitorsResultsSuccess.type:
    case actions.loadKeywordsCompetitorsChangesSuccess.type: {
      return updateCompetitors(existingKeywords, data)
    }
    default:
      return existingKeywords
  }
}

export default updateKeywords
